export default "__VITE_PUBLIC_ASSET__297d8bc4__"